import appSettings from '../config/appSettings';

const api = (queries = []) => new Promise((resolve, reject) => {
    const jsonrpc = '2.0';
    const isArray = Array.isArray(queries);
    const apiQueries = isArray ? queries : [queries];
    const queriesExt = apiQueries.map((query, id) => Object.assign({
        id,
        jsonrpc,
    }, query));
    fetch(appSettings.functionsUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(queriesExt),
    })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            return response.json();
        })
        .then((data) => {
            const compare = (a, b) => a.id - b.id;
            const resolved = data
                .sort(compare)
                .map((item) => {
                    const obj = item.error
                        ? { error: item.error.message }
                        : { result: item.result };
                    return obj;
                });
            resolve(isArray ? resolved : resolved[0]);
        })
        .catch((error) => {
            reject(error);
        });
});

export default api;



// WEBPACK FOOTER //
// ./src/service/api.js